import { popoverAnatomy, tabsAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import { mode } from '@chakra-ui/theme-tools';
import { extendTheme, ecoinventTheme, systemFontStack, StyleFunctionProps, withDefaultColorScheme } from '@ecoinvent/ui';

const chakraTheme = extendTheme(
  {
    ...ecoinventTheme,
    styles: {
      global: (props: StyleFunctionProps) => ({
        body: {
          bg: mode('blackAlpha.50', 'gray.800')(props),
          textUnderlineOffset: '0.1em',
        },
      }),
    },
    fonts: {
      heading: `'PPMori', ${systemFontStack}`,
      body: `'Inter', ${systemFontStack}`,
    },
    components: {
      ...ecoinventTheme.components,
      Input: {
        ...ecoinventTheme.components.Input,
        defaultProps: {
          focusBorderColor: 'green.500',
        },
      },
      Select: {
        defaultProps: {
          focusBorderColor: 'green.500',
        },
      },
      Tabs: createMultiStyleConfigHelpers(tabsAnatomy.keys).defineMultiStyleConfig({
        variants: {
          'soft-rounded': createMultiStyleConfigHelpers(tabsAnatomy.keys).definePartsStyle({
            tab: {
              color: mode('inherit', 'gray.100'),
              _selected: {
                _dark: {
                  bg: 'whiteAlpha.100',
                  color: 'green.300',
                },
              },
            },
          }),
        },
      }),
      Popover: createMultiStyleConfigHelpers(popoverAnatomy.keys).defineMultiStyleConfig({
        baseStyle: (props: StyleFunctionProps) => ({
          popper: {
            boxShadow: 'lg',
            borderRadius: 'md',
          },
          content: {
            bg: mode('white', 'gray.700')(props),
            color: mode('gray.700', 'whiteAlpha.900')(props),
            boxShadow: 'lg',
            textTransform: 'none',
            fontSize: 'md',
            fontWeight: 'normal',
            letterSpacing: 'normal',
            whiteSpace: 'normal',
            textAlign: 'left',
            fontFamily: 'body',
            lineHeight: 'base',
            maxW: 'sm',
          },
        }),
      }),
    },
  },
  withDefaultColorScheme({
    colorScheme: 'green',
    components: ['Button', 'Link', 'Tabs', 'Checkbox', 'Spinner', 'Select', 'Input'],
  })
);

export default chakraTheme;
